import React from 'react';
import { Link } from 'react-router-dom';
import { Users, TrendingUp, Megaphone, Handshake } from 'lucide-react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';
import { IMAGES } from '../mock';

const COMMUNITIES = ['Burk\u2019s Falls', 'Sundridge', 'South River', 'Powassan', 'Kearney', 'Magnetawan', 'Machar', 'Strong', 'Joly', 'Ryerson', 'Armour', 'Perry'];
const VALUES = [
  { icon: Megaphone, title: 'Advocacy', text: 'We are the collective voice for business, representing member interests to all levels of government.' },
  { icon: Handshake, title: 'Connection', text: 'We foster meaningful relationships and networking opportunities across the region.' },
  { icon: TrendingUp, title: 'Growth', text: 'We encourage economic growth on behalf of our members and the communities we represent.' },
  { icon: Users, title: 'Community', text: 'We build pride and collaboration throughout the Almaguin Highlands.' },
];

export default function AboutPage() {
  return (
    <>
      <PageBanner
        title="About the Chamber"
        crumb="THE CHAMBER"
        subtitle="The voice for a prosperous business community that fosters pride and collaboration within the Almaguin Highlands."
        image={IMAGES.heroA}
      />

      <section className="bg-[#f8f6f2] py-20 md:py-28">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <p className="font-sans-ah tracking-nav text-[12px] text-[#4a9cd4] font-500 mb-6">OUR MISSION</p>
          <blockquote className="font-serif-ah text-[#2f2f2f] text-[28px] md:text-[40px] font-300 leading-snug italic">
            &ldquo;To be the voice for a prosperous business community that fosters pride and collaboration within Almaguin Highlands and to encourage economic growth on behalf of its members and the communities it represents.&rdquo;
          </blockquote>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <h2 className="font-serif-ah text-[38px] md:text-[48px] text-[#2f2f2f]">What we stand for</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {VALUES.map((v) => (
              <div key={v.title} className="text-center p-8 rounded-sm bg-[#f8f6f2] hover:shadow-[0_12px_40px_rgba(0,0,0,0.08)] transition-shadow duration-400">
                <div className="w-16 h-16 rounded-full bg-[#eef4f8] flex items-center justify-center mx-auto mb-6">
                  <v.icon size={28} className="text-[#4a9cd4]" />
                </div>
                <h3 className="font-serif-ah text-[24px] text-[#2f2f2f] mb-3">{v.title}</h3>
                <p className="font-sans-ah text-[14px] text-[#666] font-300 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f8f6f2] py-20">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center">
          <p className="font-sans-ah tracking-nav text-[12px] text-[#4a9cd4] font-500 mb-4">OUR REGION</p>
          <h2 className="font-serif-ah text-[36px] md:text-[46px] text-[#2f2f2f] mb-6">The communities we represent</h2>
          <p className="font-sans-ah text-[16px] text-[#666] font-300 leading-relaxed max-w-[640px] mx-auto mb-10">
            Nestled between Muskoka and North Bay, the Almaguin Highlands is a collection of vibrant towns and townships stretching along Highway 11.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {COMMUNITIES.map((c) => (
              <span key={c} className="font-sans-ah text-[14px] text-[#3d7ca6] bg-white border border-neutral-200 px-5 py-2.5 rounded-full">{c}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#1f2c33] py-20">
        <div className="max-w-[800px] mx-auto px-6 text-center">
          <h2 className="font-serif-ah text-white text-[34px] md:text-[44px] mb-5">Ready to grow with us?</h2>
          <p className="font-sans-ah text-white/70 text-[16px] font-300 mb-8">Join a network of businesses working together to thrive in the Almaguin Highlands.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/membership" className="btn-ah-solid font-sans-ah text-[13px] px-9 py-4 rounded-sm">JOIN THE CHAMBER</Link>
            <Link to="/directory" className="btn-ah-outline font-sans-ah text-[13px] px-9 py-4 rounded-sm">VIEW DIRECTORY</Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
